import { useCountdown } from '@nv/hooks'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import RenderTBD from './RenderTBD'
import styles from './CountdownTimerBig.module.scss'

const CountdownTimerBig = ({ status, countDownDate, layout }) => {
  const { t } = useTranslation()
  const { days, hours, minutes, seconds } = useCountdown(countDownDate)
  const layoutIsColumn = layout !== 'row'

  const diffDate = new Date().getTime() - new Date(countDownDate).getTime()
  if (diffDate > 0) return <RenderTBD status={status} size={'big'} layout={layout} />

  return (
    <div
      className={clsx(styles['container'], {
        [styles['container--column']]: layoutIsColumn,
        [styles['container--row']]: !layoutIsColumn,
      })}
    >
      <span
        className={clsx(styles['title'], {
          [styles['title--column']]: layoutIsColumn,
          [styles['container--row']]: !layoutIsColumn,
        })}
      >
        {t(`countdown.label.${status}`)}
      </span>

      <div className={styles['content']}>
        <TimeCard label={t('countdown.time.long.days')} value={days} />
        <DividerColon />
        <TimeCard label={t('countdown.time.long.hours')} value={hours} />
        <DividerColon />
        <TimeCard label={t('countdown.time.long.mins')} value={minutes} />
        <DividerColon />
        <TimeCard label={t('countdown.time.long.sec')} value={seconds} />
      </div>
    </div>
  )
}

const DividerColon = () => {
  return <span className={styles['divider']}>:</span>
}

const TimeCard = ({ label, value }) => {
  return (
    <div className={styles['time-card']}>
      <span className={styles['time-card__label']}>{label}</span>

      <div className={styles['time-card__value']}>
        <span className={styles['time-card__value__txt']}>{value}</span>
      </div>
    </div>
  )
}

export default CountdownTimerBig
